import { IReferences } from '../interfaces/references.interface';

export const references: IReferences = Object.freeze({
  _CLIENT_ID: 'gerenciador_reserva_front',
  _GRANT_TYPE: 'password',

  _SCOPE:
    'grupomadero_tablereservation_api.table_reservation_read grupomadero_tablereservation_api.table_reservation_write grupomadero_tablereservation_api',
  _USER_ROLES: ['ManagerReserva', 'AdminReserva', 'UserReserva'],
  _STORAGE_TOKEN: '@tokenManager',
  _STORAGE_USER: '@userManager',
  _STORAGE_BRANCH: '@branchManager',
  _STORAGE_DATE: '@dateManager',
  _STORAGE_OLD_DATE: '@oldDateManager',
});
